import { CSSProperties, FC } from 'react';
import { Button as MUIButton } from '@mui/material';
import useButtonStyle from './ButtonStyle';

interface IButton {
  variant?: 'text' | 'outlined' | 'contained' | undefined;
  color?: 'inherit' | 'primary' | 'secondary' | 'inherit' | 'error' | undefined;
  className?: string;
  onClick?:
    | ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  isDisabled?: boolean;
  dataRole?: string;
  style?: CSSProperties;
  children: React.ReactNode;
  size?: 'medium' | 'large' | 'small';
}

const Button: FC<IButton> = ({
  variant = 'contained',
  children,
  color = 'primary',
  className,
  onClick,
  isDisabled = false,
  dataRole,
  style,
  size,
}) => {
  const classes = useButtonStyle();

  const dummyClickHandler = () => {};

  const buttonClassName = `${classes.button}${
    className ? ` ${className}` : ''
  }`;
  return (
    <MUIButton
      onClick={onClick || dummyClickHandler}
      className={buttonClassName}
      variant={variant}
      color={color}
      disabled={isDisabled}
      data-role={dataRole}
      style={style}
      size={size}
    >
      {children}
    </MUIButton>
  );
};

export default Button;
